<template>
  <b-row>
    <b-col>
      <chartjs-container :title="ChartTitle">
        <chartjs-component-horizontal-bar-chart v-if="ChartHasMeaningfulData" :height="chartHeight"
                                                :chart-data="ChartData" />
        <p v-else>
          Aucune information disponible
        </p>
      </chartjs-container>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol,
  BRow,
} from 'bootstrap-vue'
import { convertHM } from '@/@core/utils/filter'
import ChartjsContainer from '../ChartjsContainer.vue'
import ChartjsComponentHorizontalBarChart from '../charts-components/ChartjsComponentHorizontalBarChart.vue'
import useStatisticsRouteFetch from '../useStatisticsRouteFetch'
import {
  computedConfiguration, watchConfiguration, BASE_CHART_HEIGHT, chartHasMeaningfulData, TABS,
} from './baseConfiguration'

export default {
  components: {
    BCol,
    BRow,
    ChartjsContainer,
    ChartjsComponentHorizontalBarChart,
  },
  data() {
    return {
      tabname: TABS.VOLUNTEERSHOURS,
      ChartTitle: 'Temps alloué par les bénévoles',
      ChartData: {},
      chartHeight: BASE_CHART_HEIGHT,
    }
  },
  computed: {
    ChartHasMeaningfulData() {
      return chartHasMeaningfulData(this.ChartData)
    },
    ...computedConfiguration,
  },
  watch: watchConfiguration,
  methods: {
    fetchRouteOnActive() {
      if (this.active) {
        this.fetchRoute()
      }
    },
    async fetchRoute() {
      const response = await useStatisticsRouteFetch()
      if (response && Array.isArray(response)) {
        this.ChartData = this.buildChartData(response)
      }
    },
    buildChartData(data) {
      const formattedLabels = this.formatLabels(data)
      const formattedData = this.formatValues(data)
      return {
        labels: formattedLabels,
        datasets: [{
          label: 'Nombre d\'heures',
          data: formattedData,
          backgroundColor: '#15EB6B', // A noter, il faut définir une couleur (ou une palette) pour les graphs verticaux
        }],
      }
    },
    formatLabels(data) {
      // We include the hours in the label because formatValues only wants doubles (see : ChartjsComponentStackedHorizontalBarChart.vue).
      return data.map(item => `${item.labelValue.label} (${convertHM(item.labelValue.value)})`)
    },
    formatValues(data) {
      return data.map(item => item.labelValue.value)
    },
  },
}
</script>
